<h2 mat-dialog-title class="text-lg font-bold mb-1">Respuesta</h2>
<mat-dialog-content class="modal-content">
  <div class="grid grid-cols-1">
    <span>Procesados: {{total}}</span>
    <span>Insertados: {{inserted}}</span>
    <span>Actualizados: {{ updated }}</span>
    <span>Con Error: {{ error }}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-actions flex">
  <!--<button mat-button mat-dialog-close class="align-left">Cancelar</button>-->
  <div class="align-left"></div>
  <button mat-raised-button color="primary" (click)="onSubmit()" class="justify-end">Aceptar</button>
</mat-dialog-actions>